import React, { Component } from 'react';
import './Contact.css';

class Contact extends Component {


  render() {
    return (
      <div>
        <section className="contact-hero secondaryhero">
          <div className="container">
            <h1>Contact Us</h1>
          </div>
        </section>
        <section className="secondary-section contact-section">
         <div className="container">
           <h2>Contact us</h2>
           <p className="intro-para">
             Get in touch with us and we will respond as soon as we can. Thank you!
           </p>
           <p className="address-line"><b> Mailing Address: </b> <br/> 2406 Manson St. <br/> Detroit, Mi <br/> 48209 </p>
           <p className="address-line">
             <b> Telephone: </b>  <br />248-917-2064 <br/> <br/> <br/>
           </p>
           <form action="https://formspree.io/dccallas@cpakusa.com" method="POST" name="contactForm">
             <div className="form-group">
               <label>Name</label>
               <input type="text" required name="name" className="form-control"/>
             </div>
             <div className="form-group">
               <label>Email</label>
               <input type="email" required name="email"className="form-control"/>
             </div>
             <div className="form-group">
               <label>Message</label>
               <textarea type="text" required name="message" rows="10" className="form-control"></textarea>
             </div>
             <button type="submit" className="btn btn-primary">Submit</button>
            </form>
          </div>
        </section>
      </div>

    )
  }
}

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Contact.js
 **/